import baseTheme from '../../base';

export default Object.assign({}, baseTheme, {
  primary: '#0d47a1',
  secondary: '#ffeb3b',
})